import { Aperture } from 'lucide-react';

export function Brand({ light = false }: { light?: boolean }) {
  return (
    <span className={`brand ${light ? 'brand-light' : ''}`}>
      <span className="brand-symbol" aria-hidden="true">
        <Aperture size={29} strokeWidth={1.7} />
      </span>
      <span className="brand-wordmark">
        <strong>幕间</strong>
        <span className="brand-latin">MUJIAN</span>
      </span>
    </span>
  );
}
